import ToggleItem from "../Common/ToggleItem";
import Utils from "../Shared/Utils";
import UIManager from "../Shared/UIManager";
import NetworkLogic from "../Shared/NetworkLogic";
import CommonToggleContainer from "../Common/CommonToggleContainer";
import MsgCenterData from "../Models/MsgCenterData";
import AudioManager from "../Shared/AudioManager";
import EnterSoundManager from "../Shared/EnterSoundManager";
import { Global } from "../Shared/Global";
import Constant from "../Shared/Constant";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class MailBoxUI extends cc.Component {
    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null

    @property(cc.Widget)
    wgtNode: cc.Widget = null

    @property(cc.Layout)
    lytContent: cc.Layout = null

    @property(cc.Node)
    nodeTemplate: cc.Node = null

    @property(cc.Node)
    nodeMsgBox: cc.Node = null

    @property(cc.Animation)
    aniMsgBox: cc.Animation = null

    @property(cc.Label)
    lbReaded: cc.Label = null

    @property(cc.Label)
    lbTotal: cc.Label = null

    private _msgType = 0
    private _selectedItem: cc.Node = null

    onLoad() {
        this.nodeTemplate.parent = null
        this.nodeMsgBox.active = false
        this.toggleContainer.isSelectFirstItem = false
        Utils.hideGameNode()
    }

    start() {
        if (cc.winSize.width / cc.winSize.height > 2) {
            this.wgtNode.left += Constant.BangLength;
        }

        UIManager.showLoadingUI()
        this.scheduleOnce(function () {
            NetworkLogic.receiveMessage(1, 99, function (data) {
                UIManager.hideLoadingUI()
                MsgCenterData.msgList = data
                this.toggleContainer.selectFirstItem()
            }.bind(this))
        }, 0.3)
        EnterSoundManager.playSound("enter_xiaoxi")
    }

    onDestroy() {
        this.nodeTemplate.destroy()
    }

    onBtnClick(event, userData) {
        if (userData === "back") {
            AudioManager.playSound("close")
            Utils.showGameNode()
            this.node.destroy()
        } else if (userData === "item") {
            this._selectedItem = event.target

            if (!this._selectedItem["msgData"]["readed"]) {
                let id = this._selectedItem["msgData"]["id"]
                UIManager.showLoadingUI()
                NetworkLogic.noticeReaded(id, function () {
                    UIManager.hideLoadingUI()
                    MsgCenterData.readMsg(id)
                    this.readed(this._selectedItem)
                    this.refreshNum()
                }.bind(this))
            }

            AudioManager.playSound("show")
            this.nodeMsgBox.active = true
            this.aniMsgBox.play("show_msgbox")
            cc.find("bg/title", this.nodeMsgBox).getComponent(cc.Label).string = this._selectedItem["msgData"].title
            cc.find("bg/time", this.nodeMsgBox).getComponent(cc.Label).string = this._selectedItem["msgData"].publishTime
            cc.find("bg/content", this.nodeMsgBox).getComponent(cc.Label).string = this._selectedItem["msgData"].content
            cc.find("bg/type", this.nodeMsgBox).getComponent(cc.Label).string = (this._msgType === 0 ? i18n.t('msg_text.message') : i18n.t('msg_text.email'))

            // 领取状态：0：可领取 1：已领取 2：已过期
            let stateToName = ["", i18n.t('msg_text.receive'), i18n.t('msg_text.overdue')]
            cc.find("bg/type", this.nodeMsgBox).getComponent(cc.Label).string = stateToName[this._selectedItem["msgData"].validType] || ""
            cc.find("bg/btn_get", this.nodeMsgBox).active = this._selectedItem["msgData"].validType === 0
        } else if (userData === "close") {
            this._selectedItem = null
            AudioManager.playSound("close")
            this.aniMsgBox.play("hide_msgbox")
        } else if (userData === "allRead") {
            AudioManager.playSound("button")
            UIManager.showLoadingUI()
            NetworkLogic.noticeAllReaded(function () {
                UIManager.hideLoadingUI()
                MsgCenterData.readAllMsg()
                this.lytContent.node.children.forEach(child => {
                    this.readed(child)
                });
                this.refreshNum()
            }.bind(this))
        } else if (userData === "del") {
            AudioManager.playSound("button")
            if (event.target.parent.msgData["validType"] === 0) {
                UIManager.showToastUI(i18n.t('msg_text.not_delete'), Global.ToastType.Warnning)
                return
            }
            let id = event.target.parent.msgData["id"]
            UIManager.showLoadingUI()
            NetworkLogic.noticeDel(id, function () {
                UIManager.hideLoadingUI()
                MsgCenterData.delMsg(id)
                event.target.parent.destroy()
                this.refreshNum()
            }.bind(this))
        } else if (userData === "allDel") {
            AudioManager.playSound("button")
            UIManager.showLoadingUI()
            NetworkLogic.noticeDelAll(function () {
                UIManager.hideLoadingUI()
                this.lytContent.node.children.forEach(child => {
                    // 未领取不能删除
                    if (child["msgData"].validType !== 0) {
                        child.destroy()
                    }
                });
                MsgCenterData.delAllMsg()
                this.refreshNum()
                if (MsgCenterData.msgList.length > 0) {
                    UIManager.showToastUI(i18n.t('msg_text.not_be_deleted'), Global.ToastType.Warnning)
                }
            }.bind(this))
        } else if (userData === "getReward") {
            Utils.disable_btn_sec(event,5);
            AudioManager.playSound("button")
            let id = this._selectedItem["msgData"]["id"]
            let money = this._selectedItem["msgData"]["money"]
            UIManager.showLoadingUI()
            NetworkLogic.noticeReceiveAward(id, function () {
                UIManager.hideLoadingUI()
                this.nodeMsgBox.active = false
                MsgCenterData.receiveAward(id)
                this.receivedAward(this._selectedItem)
                cc.director.emit(Global.UserEvent.OpenBaoxiang, money)
            }.bind(this))
        } else if (userData === "getAllReward") {
            Utils.disable_btn_sec(event,5);
            AudioManager.playSound("button")
            UIManager.showLoadingUI()
            NetworkLogic.noticeReceiveAwardAll(function (data) {
                UIManager.hideLoadingUI()

                // 显示获取金币界面
                let moneyList = []
                for (let i = 0; i < MsgCenterData.msgList.length; i++) {
                    const item = MsgCenterData.msgList[i];
                    if (item.validType === 0 && item.money > 0) {
                        moneyList.push(item.money)
                    }
                }
                this.showGetMoneyUI(moneyList)

                // 全部领取，也代表已经全部已读
                this.lytContent.node.children.forEach(child => {
                    if (child["msgData"].validType === 0) {
                        this.readed(child)
                        this.receivedAward(child)
                    }
                });

                MsgCenterData.receiveAllAward()
                this.refreshNum()
            }.bind(this))
        }
    }

    onHideMsgBox() {
        this.nodeMsgBox.active = false
    }

    onToggleSelected(toggle: ToggleItem) {
        this.lytContent.node.destroyAllChildren()
        this.lytContent.node.removeAllChildren()
        this.lytContent.enabled = true

        if (toggle.userData === "msg") {
            this._msgType = 0
        } else if (toggle.userData === "mail") {
            this._msgType = 1
        }

        let msgs = MsgCenterData.getMsgs(this._msgType)

        for (let i = 0; i < msgs.length; i++) {
            const msg = msgs[i];
            let node = cc.instantiate(this.nodeTemplate)

            node.parent = this.lytContent.node
            node["msgData"] = msg
            node.getChildByName("title").getComponent(cc.Label).string = msg["title"]
            node.getChildByName("time").getComponent(cc.Label).string = msg["publishTime"]
            node.getChildByName("mailOpen").active = false
            node.getChildByName("mailClose").active = true
            node.getChildByName("stateWait").active = false
            node.getChildByName("stateGot").active = false
            node.getChildByName("stateOverDue").active = false

            // 领取状态：0：可领取 1：已领取 2：已过期
            let stateToName = ["stateWait", "stateGot", "stateOverDue"]
            for (let i = 0; i < stateToName.length; i++) {
                const nodeState = node.getChildByName(stateToName[i])
                i === msg.validType ? nodeState.active = true : nodeState.active = false
            }

            if (msg["readed"]) {
                this.readed(node)
            }
        }

        this.refreshNum()

        // 动画效果
        this.lytContent.updateLayout()
        this.lytContent.enabled = false

        for (let i = 0; i < this.lytContent.node.children.length; i++) {
            const node = this.lytContent.node.children[i]
            let oldPos = node.position
            node.width = node.parent.width
            node.position = cc.v2(node.x - 1000, node.y + node.height)
            node.opacity = 0
            node.runAction(cc.sequence(cc.delayTime(i * 0.1), cc.spawn(cc.moveTo(0.3, oldPos).easing(cc.easeSineOut()), cc.fadeIn(0.3).easing(cc.easeSineOut())), cc.callFunc(function (target) {
                if (target === this.lytContent.node.children[this.lytContent.node.children.length - 1]) {
                    this.lytContent.enabled = true
                }
            }.bind(this))))
        }
    }

    showGetMoneyUI(moneyList) {
        moneyList.length > 0 && cc.director.emit(Global.UserEvent.OpenBaoxiang, moneyList[0], function () {
            moneyList.splice(0, 1)
            this.showGetMoneyUI(moneyList)
        }.bind(this))
    }

    private readed(node) {
        // 已经打开的不处理
        if (node.getChildByName("mailOpen").active) {
            return
        }

        node.getChildByName("bg").opacity = 150
        node.getChildByName("mailOpen").active = true
        node.getChildByName("mailClose").active = false
    }

    private refreshNum() {
        let readedNum = 0
        let total = MsgCenterData.getMsgs(this._msgType).length.toString()

        this.lytContent.node.children.forEach(child => {
            if (!child.active) {
                return
            }

            let msgData = child["msgData"]

            if (msgData && msgData["readed"]) {
                readedNum++
            }
        });

        this.lbReaded.string = readedNum.toString()
        this.lbTotal.string = "/" + total.toString()
    }

    private receivedAward(node) {
        node.getChildByName("stateWait").active = false
        node.getChildByName("stateGot").active = true
        node.getChildByName("stateOverDue").active = false
    }
}
